window.app = window.app || {};

var manualBookingPaymentFormStyles = {
    'input': {
        'font-family': 'verdana, sans-serif',
        'color': '#646260',
        'display': 'block',
        'height': '15px',
        'padding': '0',
        'font-size': '11px',
        'line-height': '15px',
        'border': '1px solid #b8b8b8 !important'
    },
    'label': {
        'font-family': 'verdana, sans-serif',
        'color': '#666666',
        'font-size': '10px',
        'font-weight': '400'
    },
    ':disabled': {'cursor': 'not-allowed'},
};

(function($) {

    formHelper.addRule({
        form: '#manualBookStep1Info',
        status: {
            SUCCESS: '/rci_admin/manual_booking_tool/step_2',
            SESSION_EXPIRED: '/rci_admin/manage_customers'
        }
    });

    formHelper.addRule({
        form: '#form-complete-manual-booking-cybersource',
        status: {
            SUCCESS: '/rci_admin/manual_booking_tool/thank_you',
            BOOKING_ERROR: '/rci_admin/manual_booking_tool/manual_booking_error',
            SESSION_EXPIRED: '/rci_admin/manage_customers',
            PAYMENT_INFO_EXPIRED: function() {
                this.$form.find('#flex-response').val('');
            },
            CAPTURE_CONTEXT_ERROR: '/rci_admin/manual_booking_tool/manual_booking_error',
            ERROR: function() {

                this.$form.find('#flex-response').val('');

                if (this.errors[0].code === 'new-capture-context') {

                    window.app.loadFlexMicroformScript(this.data.newCaptureContextData, manualBookingPaymentFormStyles);
                }
            }
        },
        xhrReady: function(xhrOptions) {

            var $form = this.$form;

            xhrOptions.data['cybersource-3ds-success-submit'] = $form.data('cybersource-3ds-success-submit');

            window.app.flexCreateToken(xhrOptions, this);
        }
    });

    formHelper.addIPeerRule({
        // ID of the Payment form on the WWW site
        // No need to call out the form id inside the iframe
        // The selector 'form' is always used
        form: '#form-complete-manual-booking-vpos',
        status: {
            // SUCCESS is what we would do if BOTH the iframe cde
            // and the www forms are successful
            SUCCESS: '/rci_admin/manual_booking_tool/thank_you',
            BOOKING_ERROR: '/rci_admin/manual_booking_tool/manual_booking_error',
            SESSION_EXPIRED: '/rci_admin/manage_customers'
        }
    });

    formHelper.addRule({
        form: '#form-complete-manual-booking-no-payment',
        status: {
            // SUCCESS is what we would do if BOTH the iframe cde
            // and the www forms are successful
            SUCCESS: '/rci_admin/manual_booking_tool/thank_you',
            BOOKING_ERROR: '/rci_admin/manual_booking_tool/manual_booking_error',
            SESSION_EXPIRED: '/book/session_expired'
        },
        xhrReady: function(xhrOptions) {
            xhrOptions.data['peer-status'] = 'SUCCESS';
        }
    });

	formHelper.addRule({
		form: '#manualBookStep1InfoNoPayment',
		status: {
			SUCCESS: '/rci_admin/manual_booking_tool/step_2'
		},
		xhrReady: function(xhrOptions) {
			xhrOptions.data['peer-status'] = 'SUCCESS';
		}
	});

})(jQuery);

jQuery(function initCompleteManualBookingForm($) {

    $('#form-complete-manual-booking-cybersource').each(function (index, el) {

        window.app.initializeMicroform();

        var captureContextData = JSON.parse(captureContextDataJSON);

        window.app.loadFlexMicroformScript(captureContextData, manualBookingPaymentFormStyles);

        var $form = $(this);

        $form.keydown(function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
            }
        });
    });
});

jQuery(function($) {

	$('.js-manual-booking-unit-cost').blur(function(event){
		formHelper.portholeSendFHIPeerCustomEvent({"event":"toolsunitcostchange","unitCost":$(this).val()});
	});

	$('.fh-js-manualBookStep1Info-submitter').on('click',function(event){
		$('#manualBookStep1Info, #manualBookStep1InfoNoPayment').submit();
	});
});

jQuery(function($){

    $(document).on('click','.fh-js-complete-manual-booking-submitter',function(event){
        event.preventDefault();
        $('#form-complete-manual-booking-no-payment').submit();
    });
});

